<template>
  <div v-if="party" class="scroll">
    <b-row>
      <b-col>
        <h3>{{ party.internalid }} - {{ party.name }}</h3>
      </b-col>
      <b-col>
        <!-- <b-button @click="ImportFromEconomy()"
          >Uppdatera från ekonomisystem</b-button
        > -->
      </b-col>
      <!-- <b-col> Info om kunder hämtas från ekonomisystemet. </b-col> -->
      <b-col>
        <div v-if="party.locked">
          <b-icon-lock-fill variant="danger" @click="SetLock(false)"></b-icon-lock-fill>&nbsp;<b>Låst</b>
        </div>
        <div v-if="!party.locked">
          <b-icon-unlock variant="success" @click="SetLock(true)"></b-icon-unlock>&nbsp;Upplåst
        </div>
      </b-col>
    </b-row>

    <b-button-toolbar aria-label="buttons">
      <b-button-group class="mx-1">
        <b-button v-for="t in tabs" :key="t.name" @click="setTab(t.name)" :variant="t.visible ? '' : 'outline'">
          {{ t.caption }}
        </b-button>
      </b-button-group>
    </b-button-toolbar>

    <b-card v-if="isTabVisible('Description')">
      <b-card-body>
        <b-row>
          <b-col><label>Intern beskrivning:</label></b-col>
          <b-col v-if="wrkComment != party.comment">
            <b-button title="Spara ändringar" @click="commentSave()">Spara ändringar</b-button>
            <b-button @click="commentCancel()" title="Avbryt">Avbryt</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-form-textarea id="textarea" v-model="wrkComment" rows="10" max-rows="50" :readonly="false">
          </b-form-textarea>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card v-if="isTabVisible('InvoiceAddress')">
      <b-card-body>
        <placedetails :place="invPlace" :editMode="false" :partyid="party.PartyID"></placedetails>
      </b-card-body>
    </b-card>
    <b-card v-if="isTabVisible('Users')">
      <b-card-body>
        <b-row>
          <b-col>
            <b-form-input v-model="searchUser" placeholder="Sök.." aria-placeholder="Sök"></b-form-input>
          </b-col>

          <b-col>
            <b-button variant="outline" @click="NewUser">
              <b-icon-plus-circle-fill></b-icon-plus-circle-fill>
              Ny användare
            </b-button>
          </b-col>
        </b-row>
        <b-table :items="getUsers()" :sortable="true" :small="true" :fields="fields" @row-clicked="showUserInfo">
          <template v-slot:cell(locked)="row">
            <b-icon-unlock v-if="!row.item.locked" variant="success"></b-icon-unlock>
            <b-icon-lock-fill v-if="row.item.locked" variant="danger"></b-icon-lock-fill>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
    <b-modal ref="editUserModal" title="Användardetaljer" v-model="showUserEditor" @ok="showUserEditor = false" ok-only
      ok-variant="secondary" ok-title="Stäng">
      <userdetails ref="details" v-bind:userid="editUserid" v-bind:permissions="GetAllPermissions()"
        @input="userChanged" @close="showUserEditor = false"></userdetails>
    </b-modal>
  </div>
</template>
<script>
import placedetails from "../job/placedetails";
import userdetails from "./userdetails";
import BarChart from "../../components/chart/BarChart.js";
import moment from "moment";

import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "partydetails",
  props: { partyid: Number },
  components: { placedetails, userdetails, BarChart },
  data() {
    return {
      party:null,
      invPlace: null,
      tabs: [
        { name: "Description", caption: "Beskrivning", visible: true },
        // { name: "InvoiceAddress", caption: "Fakturaadress", visible: false },
        { name: "Users", caption: "Användare", visible: false },
        // { name: "Stats", caption: "Statistik", visible: false },
      ],
      fields: [
        {
          key: "username",
          label: "Användarnamn",
          sortable: true,
        },
        {
          key: "firstname",
          label: "Förnamn",
          sortable: true,
        },
        {
          key: "lastname",
          label: "Efternamn",
          sortable: true,
        },
        {
          key: "email",
          label: "Epost",
          sortable: true,
        },
        {
          key: "phone",
          label: "Telefon",
          sortable: true,
        },
        {
          key: "latestactivity",
          label: "Senast aktiv",
          sortable: true,
          formatter: (value, key, item) => {
            if (value)
              return moment(String(value)).format('YYYY-MM-DD HH:mm')
            return "-";
          }
        },
        {
          key: "locked",
          label: "Lås",
          sortable: true,
        },
      ],
      wrkComment: null,
      basics: null,
      editUserid: null,
      showUserEditor: false,
      statData: null,
      statOpts: {
        responsive: true,
        height: "300px",
        position: "relative",
        maintainAspectRatio: false,
      },
      colors: ["#f87979", "blue", "red", "orange"],
      grpby: "week",
      transportors: [],
      partyEditMode: false,
      searchUser: null,
    };
  },
  created() {
    console.log("Partydetails created");
    //TODO: Make common
    if (!this.basics) {
      api.get("/api/party/getbasics").then((res) => {
        this.basics = res.data;
      });
      this.getData();
    }
  },
  watch: {
    partyid: function () {
      this.getData();
    },
  },
  methods: {
    getData() {
      if (this.partyid) {
        api.get("/api/party/GetDetails?id=" + this.partyid).then((res) => {
          //this.currentParty = res.data;
          this.party = res.data;
          console.log(this.party);
          this.wrkComment = this.party.comment;
        });

        // console.log(this.partyid);
        // this.wrkComment = this.party.comment;
        // if (this.party.invoicePlaceId) {
        //   var url = "/api/apiplace/GetPlace?placeId=" + this.party.invoicePlaceId;
        //   api.get(url).then((res) => {
        //     console.log(res);
        //     this.invPlace = res.data;
        //   });
        // }
      }
    },
    isTabVisible(name) {
      var t = this.getTab(name);
      return t && t.visible;
    },
    getTab(name) {
      return this.tabs.find((x) => x.name.toLowerCase() == name.toLowerCase());
    },
    setTab(name) {
      this.tabs.map((x) => (x.visible = false));
      this.getTab(name).visible = true;
      if (name == "Stats") this.refreshStats();
    },
    commentSave() {
      var p = { id: this.party.partyid, comment: this.wrkComment };
      api.post("/api/party/ChangeParty", p).then((res) => {
        if (res.data) {
          alert(res.data);
          return;
        }
        this.party.comment = this.wrkComment;
        this.partyEditMode = false;
      });
    },
    commentCancel() {
      this.wrkComment = this.party.comment;
    },
    SetLock(l) {
      if (confirm("Vill du " + (l ? "låsa" : "låsa upp") + " företaget?")) {
        var p = { id: this.party.partyid, locked: l };
        api.post("/api/party/SetLocked", p).then((res) => {
          if (res.data) {
            alert(res.data);
            return;
          }
          this.party.locked = l;
        });
      }
    },
    refreshStats() {
      if (this.party) {
        var p = api.params({
          partyId: this.party.partyid,
          groupby: this.grpby,
        });
        var url = "/api/Party/GetStats?" + p;
        api.get(url).then((res) => {
          if (res.data.errMsg) {
            alert(res.data.errMsg);
            return;
          }
          this.statData = res.data;
          for (var i = 0; i < this.statData.datasets.length; i++)
            this.statData.datasets[i].backgroundColor = this.colors[i];
        });
      }
    },
    showUserInfo(r) {
      console.log(r);
      //alert('Show userinfo');
      this.showUserInfoDialog(r.userid);
    },
    showUserInfoDialog(userid) {
      this.editUserid = userid;
      this.showUserEditor = true;
    },
    GetAllPermissions() {
      if (this.basics && this.basics.Permissions)
        return this.basics.Permissions;
      return [];
    },
    userChanged() {
      this.$emit("input", this.party);
      this.getData();
    },
    NewUser() {
      var username = prompt("Ange användarnamn:");
      if (username) {
        if (username.indexOf(" ") >= 0) {
          alert("Får inte innehålla mellanslag.");
        }
        var p = { partyid: this.party.partyid, username: username };
        api.post("/api/party/CreateNewUser", p).then((res) => {
          if (res.data.err) {
            alert(res.data.err);
            return;
          }
          this.userChanged();
          this.showUserInfoDialog(res.data.user.userid);
        });
      }
    },
    ImportFromEconomy() {
      alert("Import from erp");
      api
        .post(
          "/api/apieconomy/UpdatePartyInTpWithPartyId?partyid=" +
          this.party.partyid
        )
        .then((res) => {
          this.userChanged();
        });
    },
    getTransportorNummer() {
      api
        .get("/api/Avr/GetTransportors?partyId=" + this.party.partyid)
        .then((res) => {
          this.transportors = res.data;
        });
    },
    AddTransportorsNr() {
      var tspNr = prompt("Lägg till transportörsnummer");
      if (tspNr) {
        api.get("/api/Avr/GetTransportors").then((res) => {
          var curr = res.data.find((x) => x.TransportorsNr == tspNr);
          if (curr == null) {
            alert(
              `Ogiltigt transportörsnummer: ${tspNr}. Finns inte i systemet.`
            );
            return;
          }
          if (curr.PartyId) {
            if (curr.PartyId == this.party.partyid) {
              alert(`Transportörsnummer ${tspNr} är redan tillagt.`);
              return;
            }
            if (
              !confirm(
                `Transportörsnummer ${tspNr} är redan associerat till en transportör. Vill du flytta den hit?`
              )
            )
              return;
          }
          //Set party
          curr.PartyId = this.party.partyid;
          curr.Active = false;
          api.put("/api/Avr/SetTransporter", curr).then((res) => {
            this.getTransportorNummer();
          });
        });
      }
    },
    RemoveTransportorsNr(t) {
      if (confirm(`Vill du ta bort ${t.TransportorsNr}?`)) {
        t.PartyId = null;
        t.Active = false;
        api.put("/api/Avr/SetTransporter", t).then((res) => {
          this.getTransportorNummer();
        });
      }
    },
    SetTransporterActive(t, val) {
      var act = val ? "aktivera" : "inaktivera";
      if (confirm(`Vill du ${act} ${t.TransportorsNr}?`)) {
        t.Active = val;
        api.put("/api/Avr/SetTransporter", t).then((res) => {
          this.getTransportorNummer();
        });
      }
    },
    getUsers() {
      if (this.party && this.party.users) {
        var res = this.party.users;
        if (this.searchUser) {
          var sf = this.searchUser.toLowerCase();
          res = res.filter(x => `${x.username}|${x.firstname}|${x.lastname}|${x.email}|${x.phone}`.toLowerCase().indexOf(sf) >= 0);
        }
        return res;
      }

    }

  },
};
</script>
<style scoped>
.small {
  max-width: 600px;
  height: 450px;
  margin: 15px auto;
}
.scroll {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}

</style>>
